const AnimatedCard = ({ animation, digit }) => {
	return (
		<div className={`vs--live-monitor-flipCard ${animation}`}>
			<span className="digit">{digit}</span>
		</div>
	);
};

export default AnimatedCard;
